import React from 'react';
import { Box } from '@material-ui/core';
import { sortBy } from 'lodash/fp';
import { eventTypeToComponentMap } from './TimelineItems';
import ArrowDown from './ArrowDown';
import { TimelineProps } from './types';

const TimelineView = ({ timeline }: TimelineProps) => {
    const orderedTimeline = sortBy('timestamp', timeline);

    return (
        <Box width="100%" maxWidth={500} my={5}>
            {orderedTimeline.map((audit, i) => {
                    const TimelineItem = eventTypeToComponentMap[audit.eventType];

                    return (
                        <React.Fragment key={`${audit.eventId} - ${audit.eventType}`}>
                            <TimelineItem {...audit} />
                            {(timeline.length - 1) > i && <ArrowDown />}
                        </React.Fragment>
                    );
                })}
        </Box>
    );
};

export default TimelineView;
